<template>
    <div class="card">
        <Toast />
        <ConfirmDialog/>
        <div class = "button-row">
            <Button label="조회" icon="pi pi-search" class="p-button-success mr-2" @click="btnAct('SEARCH')" />
            <Button label="엑셀" icon="pi pi-download" class="mr-2" @click="downloadExcel($event)"  />
            <Button label="CSV" icon="pi pi-download" class="mr-2" @click="exportCSV($event)"  />
        </div>
        <Toolbar>
            <template #start>
                <div class="grid">
                    <div class="p-field p-float-label m-2">
                        <InputText id="userId" type="text" v-model.trim="searchParams.userId" @keydown.enter="btnAct('SEARCH')" style="width:10em"/>
                        <label for="userId">사용자아이디</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <InputText id="userNm" type="text" v-model.trim="searchParams.userNm" @keydown.enter="btnAct('SEARCH')"  style="width:10em"/>
                        <label for="userNm">사용자명</label>
                    </div>
                    <div class="p-field p-float-label m-auto" style="width: 8rem">
                        <Calendar v-model="searchParams.fromDate" :monthNavigator="true" :yearNavigator="true" yearRange="2010:2099" showButtonBar style="width: 8rem" />
                        <label>시작일자</label>
                    </div>
                    <div class="p-field p-float-label m-auto mr-2" style="width: 1rem">
                        <label>~</label>
                    </div>
                    <div class="p-field p-float-label m-auto" style="width: 8rem">
                        <Calendar v-model="searchParams.toDate" :monthNavigator="true" :yearNavigator="true" yearRange="2010:2099" showButtonBar style="width: 8rem" />
                        <label>종료일자</label>
                    </div>
                </div> 
            </template>

            <template #end>
                
            </template>
        </Toolbar>
        
        <DataTable id="dt" ref="dt" :value="dataList" class="p-datatable-sm" scrollHeight="79vh"
            rowIndexVar="rowIndex" :loading="loading"
            stateStorage="local" stateKey="dt-state-demo-local" responsiveLayout="scroll">
            <Column field="id" header="ID" :sortable="true"></Column>
            <Column field="userId" header="아이디" :sortable="true"></Column>
            <Column field="userNm" header="사용자명" :sortable="true" ></Column>
            <Column field="loginDt2" header="로그인일시" :sortable="true"></Column>
            <Column field="logoutDt2" header="로그아웃일시"></Column>
            <Column field="usageTime2" header="사용시간"></Column>
        </DataTable>
    </div>
</template>

<script>
import { ref, onMounted, reactive } from 'vue';
import LoginLogService from '@/service/cm/LoginLogService';
import JsUtils from '@/utilities/JsUtils';

export default {
    setup() {
        onMounted(() => {
            searchParams.compSeq = 1;

            // 검색조건에 시작일자(현재일자 기준 1주일 전),종료일자(현재일자)를 표시한다
            let fromDate = new Date();  
            fromDate.setDate(fromDate.getDate());
            searchParams.fromDate = JsUtils.getDateString(fromDate);
            searchParams.toDate = JsUtils.getDateString(new Date());

            searchList();
        })
        const searchParams = reactive({userId:null,userNm:null,fromDate:null,toDate:null});
        const dataList = ref([]);
        const dt = ref();

		const loginLogService= new LoginLogService();

        const btnAct = (_act) =>
        {
            switch(_act)
            {
                case "SEARCH":
                        searchList();
                    break;
            }
        }

        const searchList = () => {
            loginLogService.getList(searchParams).then(data=> {
                dataList.value = data;
            });
        }

        // 액셀 다운로드
        const downloadExcel = () => {
            // datatable(즉, dataList.value)에 있는 모든 항목들을 엑셀 파일로 다운로드 한다 - 컬럼명이 필드(영문)으로 나옴
            //JsUtils.downloadExcel(dataList.value);

            // table의 html 내용을 그대로 엑셀 파일로 다운로드 한다 - paging 사용 시 해당 한 페이지만 다운로드 됨
            JsUtils.downloadExcel2('dt');  // id='dt'
        }

        // CSV 다운로드
        const exportCSV = () => { 
            dt.value.exportCSV();   // dt는 ref="dt"
        };

        return { 
            dt, dataList, searchParams, 
            btnAct, downloadExcel, exportCSV,
        }
    }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 960px) {
	::v-deep(.p-toolbar) {
		flex-wrap: wrap;
        
		.p-button {
            margin-bottom: 0.25rem;
        }
	}
}
</style>
